import React from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

import Home from "./pages/Home";
import Users from "./pages/Users";
import UserOne from "./pages/UserOne";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Email from "./pages/Email";
import Login from "./pages/Login";
import Reports from "./pages/Reports";
import MyProfile from "./pages/MyProfile";

const getUserRole = () => {
  const token = Cookies.get("authToken");

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken.claims.role;
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }
  return null;
};

function AppLayout({ children }) {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";

  return isLoginPage ? (
    children
  ) : (
    <div className="container-scroller">
      <Sidebar />
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">{children}</div>
        </div>
      </div>
    </div>
  );
}

const ProtectedRoute = ({ allowedRole, children }) => {
  const token = Cookies.get("authToken");
  const userRole = getUserRole();

  if (!token) {
    Object.keys(Cookies.get()).forEach((cookie) => Cookies.remove(cookie));
    return <Navigate to="/login" replace />;
  }

  if (allowedRole && userRole !== allowedRole) {
    Object.keys(Cookies.get()).forEach((cookie) => Cookies.remove(cookie));
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default function App() {
  return (
    <Router>
      <AppLayout>
        <Routes>
          {/* Default route - protected */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Navigate to="/dashboard" />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<Login />} />
          {/* <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/email"
            element={
              <ProtectedRoute>
                <Email />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-profile"
            element={
              <ProtectedRoute>
                <MyProfile />
              </ProtectedRoute>
            }
          />
          {/* Admin-only Routes */}
          <Route
            path="/reports"
            element={
              <ProtectedRoute allowedRole="ADMIN">
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute allowedRole="ADMIN">
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRole="ADMIN">
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user/:id"
            element={
              <ProtectedRoute allowedRole="ADMIN">
                <UserOne />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AppLayout>
    </Router>
  );
}
